import React from 'react';

export default function ConfirmDeleteAdvertisementFoodDetail() {
  return <>ConfirmDeleteAdvertisementFoodDetail</>;
}
